


















import {Component, Inject, Ref, Vue, Watch} from 'vue-property-decorator'
import PtToast from '@patsnap-biz/toast';
import {errorCaptured, mayHandleError} from './errorHandler'
import {withLoading} from './utils/task'
import {CASE_TIME_CONTEXT} from './constatnts'
import {Context} from './context'
import { Service as WidgetService } from '../Service';

import CaseTimeButton from './components/CaseTimeButton/CaseTimeButton.vue'
import CaseTimeDialog from './components/CaseTimeDialog/CaseTimeDialog.vue'
import {
    E_CaseTimeAction,
    IPutCaseOperationParams,
    IUserCaseItem,
    E_CurrentStatus,
    ICaseTimeForm
} from './service/caseTime.types'
import {forceJson} from './utils/lang'
import {i18nOption} from './i18n/i18n'
import _ from "lodash";
import type {HeaderService} from "@patsnap-utils/biz";

@Component({
    name: 'CaseTime',
    errorCaptured,
    components: {
        CaseTimeButton,
        CaseTimeDialog,
    },
    i18n: i18nOption,
})
class CaseTimeImpl extends Vue {
    @Inject(CASE_TIME_CONTEXT)
    context: Context

    @Inject('service')
    headerService: HeaderService

    @Ref()
    caseTimeDialogRef!: CaseTimeDialog

    loading = false
    userCaseItem = forceJson<IUserCaseItem>({})

    @Watch('CurrentStatus')
    onStatusChange(value: E_CurrentStatus) {
        this.$emit('change-status', value)
        try {
            const statusChangeEvent = new CustomEvent(WidgetService.CustomEventName, {
                detail: {
                    action: 'statusChange',
                },
            });
            window.dispatchEvent(statusChangeEvent);
        } catch (e) {
            console.error(e);
        }
    }

    get CurrentStatus() {
        return this.context.Service.CurrentStatus
    }


    get CaseTimeDetailUrl() {
        return this.context.CaseTimeDetailUrl
    }

    get ShowButton() {
        return !this.context.config.hiddenButton
    }

    onClickRecordButton() {
        this.caseTimeDialogRef.Show()
    }

    async onUpdateCaseTime(params: { action: E_CaseTimeAction, form: ICaseTimeForm }) {
        const {
            action,
            form,
        } = params
        const {
            title,
            description,
        } = form
        const putOperationParams: IPutCaseOperationParams = {
            action,
            title,
            description,
        }

        try {
            const task = this.context.Service.putAndUpdateCase(putOperationParams)
            await withLoading(this, task)
            if (action === E_CaseTimeAction.START || action === E_CaseTimeAction.RESTART) {
                this.caseTimeDialogRef.Hidden()

                PtToast({
                    message: this.$t('case_time.start_success_tip', {name: putOperationParams.title}),
                    type: 'success',
                    showClose: true,
                })

            } else if (action === E_CaseTimeAction.END) {
                PtToast({
                    message: this.$t('case_time.end_success_tip'),
                    type: 'success',
                    showClose: true,
                })
                this.caseTimeDialogRef.ClearForm()
            }

        } catch (e) {
            mayHandleError(this, e)
        }
    }

    async mounted() {
        try {
            await this.context.Service.updateEnabled()
            await this.refreshStatus();
        } catch (e) {
            mayHandleError(this, e)
        }

        await this.$nextTick()
        this.context.setDialog(this.caseTimeDialogRef)

        this.bindLogoutCall(true)

        if (this.context.Service.needAutoPopup && !this.context.Service.isWorking) {
            this.caseTimeDialogRef.Show()
        }

        if (this.context.Service.enabled) {
            this.bindCustomRefreshEvent(true)
        }
    }


    beforeLogoutHandler() {
        // 登出时，如果症状计时，需要弹出
        if (this.context.Service.isWorking) {
            this.context.showDialog({warnMsg: this.$t('case_time.beforeLogoutTip') as string, msgType: "error"});
            return Promise.reject('Project Timer need to stop')
        }
        return Promise.resolve();
    }

    bindLogoutCall(bind: boolean) {
        const beforeLogoutHandlers = (_.get(this, 'headerService.userCenterService.beforeLogoutHandlers') as Set<Function>) || undefined;
        const beforeSwitchTenantHandlers = (_.get(this, 'headerService.userCenterService.beforeSwitchTenantHandlers') as Set<Function>) || undefined;
        if (!beforeLogoutHandlers || !beforeSwitchTenantHandlers) {
            console.warn('userCenterService.beforeLogoutHandlers not exist');
            return
        }
        if (bind) {
            beforeLogoutHandlers.add(this.beforeLogoutHandler);
            beforeSwitchTenantHandlers.add(this.beforeLogoutHandler);
        } else {
            beforeLogoutHandlers.delete(this.beforeLogoutHandler);
            beforeSwitchTenantHandlers.delete(this.beforeLogoutHandler);
        }
    }

    async refreshStatus() {
        if (this.context.Service.enabled) {
            await this.context.Service.updateCurrentUserCaseView()
        }
    }

    onOutsideRefreshEvent(evt?:CustomEvent) {
        if(_.get(evt,'detail.action') === 'refresh') {
            this.refreshStatus()
        }
    }

    bindCustomRefreshEvent(bol:boolean) {
        const action = bol ? 'addEventListener':'removeEventListener';
        // @ts-ignore
        window[action](WidgetService.CustomEventName, this.onOutsideRefreshEvent);
    }

    beforeDestroy() {
        this.context.setDialog(null)
        this.bindLogoutCall(false)
        this.bindCustomRefreshEvent(false)
    }
}

export default CaseTimeImpl
